import { theme as bt, Menu as sn, Modal as xt } from "antd";
import Qr from "i18next";
import { select as Sr, listify as cn, mapEntries as un, merge as ln } from "radash";
import { generatePath as fn, useParams as wt, useSearchParams as Rt, useNavigate as Et, Outlet as dn } from "react-router-dom";
import pn from "axios";
import * as ge from "react";
import L, { createContext as mn, useContext as vn, useEffect as hn } from "react";
import { Icon as Q } from "@nubeteck/icons";
import { Box as ie, Result as ye, ErrorSVG as Tt, Flex as U, Button as ze, Paragraph as _t, Text as jr, IconText as Ce, SuccessSVG as Ct, Constants as X, Heading as gn, Steps as yn, Divider as bn, Form as xn, Avatar as wn, Skeleton as Pr, DocsSVG as Rn, Card as Kr } from "@nubeteck/components";
import { useQuery as Ge, useMutation as St } from "@tanstack/react-query";
import he from "react-hot-toast";
import { QueryHooks as kr, QueryStatus as En } from "@nubeteck/queries";
import { JsxUtil as jt, Datejs as Xr, ArrayUtils as Zr, EventUtils as Tn } from "@nubeteck/utils";
import W from "styled-components";
import { DatePicker as _n, InputNumber as Cn, Input as Sn, Select as Or, Segmented as jn, useForm as Pn, Formeck as xr, FormGrid as nr } from "@nubeteck/formeck";
const kn = "GET_REPORT", On = "GET_TICKET", In = "REPORTS", An = "REPORTS_CATEGORIES", Mn = "REPORTS_GLOBAL_ENDPOINT", Pt = "/reporting", kt = "/pdf/:reportName", Ot = "/ticket/:reportName", Fn = 1, Dn = 2, $r = 3, Nn = 4, $n = 1, Ln = 2, Un = 3, Vn = 5, Bn = 6, Wn = "Reportes", zn = "GetReport", qn = "GetTicket", Gn = "ReportesCategorias", Hn = "ObtenerReporte", Yn = "http://localhost:1299/print?printer=", Jn = "http://localhost:1299/version", Qn = {
  error_unhandled: "This error is not being handled.",
  error_required: "This field is required"
}, Kn = {
  error_unhandled: "Este error no se está manejando.",
  error_required: "Este campo es obligatorio"
}, et = {
  en: Qn,
  es: Kn
}, Xn = "Example", Zn = {
  key: Xn
}, ea = "Ejemplo", ra = {
  key: ea
}, ta = [
  {
    "message-en": "There was an error connecting to the server.",
    "message-es": "Hubo un error al conectar con el servidor.",
    keys: [
      "network"
    ]
  },
  {
    "message-en": "Timeout. Please try again later.",
    "message-es": "Tiempo de espera agotado. Por favor, inténtalo nuevamente más tarde.",
    keys: [
      "timeout"
    ]
  },
  {
    "message-en": "We couldn't find the template for this report.",
    "message-es": "No pudimos encontrar la plantilla para este informe.",
    keys: [
      "stored",
      "procedure"
    ]
  },
  {
    "message-en": "We couldn't find the template for this report.",
    "message-es": "No pudimos encontrar la plantilla para este informe.",
    keys: [
      "find",
      "file",
      ".html"
    ]
  },
  {
    "message-en": "A required parameter was not specified.",
    "message-es": "No se especificó un parámetro requerido.",
    keys: [
      "supplied",
      "parameter"
    ]
  }
], rt = (e) => {
  const t = e.toLowerCase(), r = Qr.language.includes("es") ? "es" : Qr.language;
  return Sr(ta, (a) => r === "en" ? a["message-en"] : a["message-es"], (a) => a.keys.every((s) => t.includes(s)));
}, It = process.env.NUBETECK_SERVER_URL ?? "";
if (!It)
  throw new Error("Please add your Server URL to environment variables.");
const ve = (e) => {
  const t = localStorage.getItem("token"), r = pn.create({
    params: e,
    timeout: 1e6,
    baseURL: It,
    headers: { Authorization: `Bearer ${t}` }
  });
  return r.interceptors.response.use((a) => a, (a) => a.response ? Promise.reject(rt(a.response.data?.Result?.OuterException ?? "").join(" ")) : Promise.reject(rt(a.message).join(""))), r;
}, pe = {
  getAll: async () => (await ve().get(Wn)).data.Result,
  verifyService: async () => (await ve().get(Jn)).data.Result,
  getByProc: async (e) => (await ve().get(`${Hn}/${e}`)).data.Result,
  generate: async (e, t) => (await ve().post(zn, {
    reportName: e,
    reportData: t
  })).data.Result,
  print: async ({ data: e, printer: t }) => (await ve().post(Yn + t, e)).status !== 200 ? "fail" : "success",
  generateTicket: async (e) => (await ve().post(qn, {
    reportData: e
  })).data.Result
}, Lr = (e, t, r = "pdf") => `${Pt}${fn(r === "pdf" ? kt : Ot, { reportName: e })}?${cn(t, (a, s) => `${a}=${s}`).join("&")}`, na = async (e) => {
  const t = await pe.generateTicket(e);
  return await pe.print({
    data: t.formato,
    printer: t.impresoraNombre
  });
};
var tt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function aa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ir = { exports: {} }, Ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nt;
function oa() {
  if (nt)
    return Ve;
  nt = 1;
  var e = L, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(m, v, R) {
    var E, b = {}, k = null, A = null;
    R !== void 0 && (k = "" + R), v.key !== void 0 && (k = "" + v.key), v.ref !== void 0 && (A = v.ref);
    for (E in v)
      a.call(v, E) && !c.hasOwnProperty(E) && (b[E] = v[E]);
    if (m && m.defaultProps)
      for (E in v = m.defaultProps, v)
        b[E] === void 0 && (b[E] = v[E]);
    return { $$typeof: t, type: m, key: k, ref: A, props: b, _owner: s.current };
  }
  return Ve.Fragment = r, Ve.jsx = d, Ve.jsxs = d, Ve;
}
var Be = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var at;
function ia() {
  return at || (at = 1, process.env.NODE_ENV !== "production" && function() {
    var e = L, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), m = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), G = Symbol.iterator, V = "@@iterator";
    function Z(n) {
      if (n === null || typeof n != "object")
        return null;
      var l = G && n[G] || n[V];
      return typeof l == "function" ? l : null;
    }
    var H = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(n) {
      {
        for (var l = arguments.length, h = new Array(l > 1 ? l - 1 : 0), x = 1; x < l; x++)
          h[x - 1] = arguments[x];
        xe("error", n, h);
      }
    }
    function xe(n, l, h) {
      {
        var x = H.ReactDebugCurrentFrame, P = x.getStackAddendum();
        P !== "" && (l += "%s", h = h.concat([P]));
        var O = h.map(function(j) {
          return String(j);
        });
        O.unshift("Warning: " + l), Function.prototype.apply.call(console[n], console, O);
      }
    }
    var Pe = !1, ke = !1, cr = !1, ur = !1, lr = !1, He;
    He = Symbol.for("react.module.reference");
    function fr(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === a || n === c || lr || n === s || n === R || n === E || ur || n === A || Pe || ke || cr || typeof n == "object" && n !== null && (n.$$typeof === k || n.$$typeof === b || n.$$typeof === d || n.$$typeof === m || n.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === He || n.getModuleId !== void 0));
    }
    function dr(n, l, h) {
      var x = n.displayName;
      if (x)
        return x;
      var P = l.displayName || l.name || "";
      return P !== "" ? h + "(" + P + ")" : h;
    }
    function se(n) {
      return n.displayName || "Context";
    }
    function Y(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case c:
          return "Profiler";
        case s:
          return "StrictMode";
        case R:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case m:
            var l = n;
            return se(l) + ".Consumer";
          case d:
            var h = n;
            return se(h._context) + ".Provider";
          case v:
            return dr(n, n.render, "ForwardRef");
          case b:
            var x = n.displayName || null;
            return x !== null ? x : Y(n.type) || "Memo";
          case k: {
            var P = n, O = P._payload, j = P._init;
            try {
              return Y(j(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, ce = 0, Oe, Ie, Ae, Me, Fe, I, ne;
    function Ye() {
    }
    Ye.__reactDisabledLog = !0;
    function F() {
      {
        if (ce === 0) {
          Oe = console.log, Ie = console.info, Ae = console.warn, Me = console.error, Fe = console.group, I = console.groupCollapsed, ne = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        ce++;
      }
    }
    function pr() {
      {
        if (ce--, ce === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, n, {
              value: Oe
            }),
            info: ee({}, n, {
              value: Ie
            }),
            warn: ee({}, n, {
              value: Ae
            }),
            error: ee({}, n, {
              value: Me
            }),
            group: ee({}, n, {
              value: Fe
            }),
            groupCollapsed: ee({}, n, {
              value: I
            }),
            groupEnd: ee({}, n, {
              value: ne
            })
          });
        }
        ce < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = H.ReactCurrentDispatcher, Ne;
    function we(n, l, h) {
      {
        if (Ne === void 0)
          try {
            throw Error();
          } catch (P) {
            var x = P.stack.trim().match(/\n( *(at )?)/);
            Ne = x && x[1] || "";
          }
        return `
` + Ne + n;
      }
    }
    var z = !1, me;
    {
      var ue = typeof WeakMap == "function" ? WeakMap : Map;
      me = new ue();
    }
    function $e(n, l) {
      if (!n || z)
        return "";
      {
        var h = me.get(n);
        if (h !== void 0)
          return h;
      }
      var x;
      z = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = De.current, De.current = null, F();
      try {
        if (l) {
          var j = function() {
            throw Error();
          };
          if (Object.defineProperty(j.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(j, []);
            } catch (ae) {
              x = ae;
            }
            Reflect.construct(n, [], j);
          } else {
            try {
              j.call();
            } catch (ae) {
              x = ae;
            }
            n.call(j.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ae) {
            x = ae;
          }
          n();
        }
      } catch (ae) {
        if (ae && x && typeof ae.stack == "string") {
          for (var _ = ae.stack.split(`
`), B = x.stack.split(`
`), M = _.length - 1, N = B.length - 1; M >= 1 && N >= 0 && _[M] !== B[N]; )
            N--;
          for (; M >= 1 && N >= 0; M--, N--)
            if (_[M] !== B[N]) {
              if (M !== 1 || N !== 1)
                do
                  if (M--, N--, N < 0 || _[M] !== B[N]) {
                    var J = `
` + _[M].replace(" at new ", " at ");
                    return n.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", n.displayName)), typeof n == "function" && me.set(n, J), J;
                  }
                while (M >= 1 && N >= 0);
              break;
            }
        }
      } finally {
        z = !1, De.current = O, pr(), Error.prepareStackTrace = P;
      }
      var _e = n ? n.displayName || n.name : "", Jr = _e ? we(_e) : "";
      return typeof n == "function" && me.set(n, Jr), Jr;
    }
    function mr(n, l, h) {
      return $e(n, !1);
    }
    function Je(n) {
      var l = n.prototype;
      return !!(l && l.isReactComponent);
    }
    function Re(n, l, h) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return $e(n, Je(n));
      if (typeof n == "string")
        return we(n);
      switch (n) {
        case R:
          return we("Suspense");
        case E:
          return we("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case v:
            return mr(n.render);
          case b:
            return Re(n.type, l, h);
          case k: {
            var x = n, P = x._payload, O = x._init;
            try {
              return Re(O(P), l, h);
            } catch {
            }
          }
        }
      return "";
    }
    var Ee = Object.prototype.hasOwnProperty, Qe = {}, Ke = H.ReactDebugCurrentFrame;
    function le(n) {
      if (n) {
        var l = n._owner, h = Re(n.type, n._source, l ? l.type : null);
        Ke.setExtraStackFrame(h);
      } else
        Ke.setExtraStackFrame(null);
    }
    function vr(n, l, h, x, P) {
      {
        var O = Function.call.bind(Ee);
        for (var j in n)
          if (O(n, j)) {
            var _ = void 0;
            try {
              if (typeof n[j] != "function") {
                var B = Error((x || "React class") + ": " + h + " type `" + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[j] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw B.name = "Invariant Violation", B;
              }
              _ = n[j](l, j, x, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              _ = M;
            }
            _ && !(_ instanceof Error) && (le(P), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", h, j, typeof _), le(null)), _ instanceof Error && !(_.message in Qe) && (Qe[_.message] = !0, le(P), $("Failed %s type: %s", h, _.message), le(null));
          }
      }
    }
    var hr = Array.isArray;
    function Le(n) {
      return hr(n);
    }
    function Ue(n) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, h = l && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return h;
      }
    }
    function o(n) {
      try {
        return i(n), !1;
      } catch {
        return !0;
      }
    }
    function i(n) {
      return "" + n;
    }
    function u(n) {
      if (o(n))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ue(n)), i(n);
    }
    var p = H.ReactCurrentOwner, g = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, D, w, T;
    T = {};
    function y(n) {
      if (Ee.call(n, "ref")) {
        var l = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function C(n) {
      if (Ee.call(n, "key")) {
        var l = Object.getOwnPropertyDescriptor(n, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function S(n, l) {
      if (typeof n.ref == "string" && p.current && l && p.current.stateNode !== l) {
        var h = Y(p.current.type);
        T[h] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(p.current.type), n.ref), T[h] = !0);
      }
    }
    function te(n, l) {
      {
        var h = function() {
          D || (D = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        h.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: h,
          configurable: !0
        });
      }
    }
    function Xe(n, l) {
      {
        var h = function() {
          w || (w = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        h.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: h,
          configurable: !0
        });
      }
    }
    var Qt = function(n, l, h, x, P, O, j) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: n,
        key: l,
        ref: h,
        props: j,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function Kt(n, l, h, x, P) {
      {
        var O, j = {}, _ = null, B = null;
        h !== void 0 && (u(h), _ = "" + h), C(l) && (u(l.key), _ = "" + l.key), y(l) && (B = l.ref, S(l, P));
        for (O in l)
          Ee.call(l, O) && !g.hasOwnProperty(O) && (j[O] = l[O]);
        if (n && n.defaultProps) {
          var M = n.defaultProps;
          for (O in M)
            j[O] === void 0 && (j[O] = M[O]);
        }
        if (_ || B) {
          var N = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          _ && te(j, N), B && Xe(j, N);
        }
        return Qt(n, _, B, P, x, p.current, j);
      }
    }
    var gr = H.ReactCurrentOwner, Wr = H.ReactDebugCurrentFrame;
    function Te(n) {
      if (n) {
        var l = n._owner, h = Re(n.type, n._source, l ? l.type : null);
        Wr.setExtraStackFrame(h);
      } else
        Wr.setExtraStackFrame(null);
    }
    var yr;
    yr = !1;
    function br(n) {
      return typeof n == "object" && n !== null && n.$$typeof === t;
    }
    function zr() {
      {
        if (gr.current) {
          var n = Y(gr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Xt(n) {
      {
        if (n !== void 0) {
          var l = n.fileName.replace(/^.*[\\\/]/, ""), h = n.lineNumber;
          return `

Check your code at ` + l + ":" + h + ".";
        }
        return "";
      }
    }
    var qr = {};
    function Zt(n) {
      {
        var l = zr();
        if (!l) {
          var h = typeof n == "string" ? n : n.displayName || n.name;
          h && (l = `

Check the top-level render call using <` + h + ">.");
        }
        return l;
      }
    }
    function Gr(n, l) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var h = Zt(l);
        if (qr[h])
          return;
        qr[h] = !0;
        var x = "";
        n && n._owner && n._owner !== gr.current && (x = " It was passed a child from " + Y(n._owner.type) + "."), Te(n), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, x), Te(null);
      }
    }
    function Hr(n, l) {
      {
        if (typeof n != "object")
          return;
        if (Le(n))
          for (var h = 0; h < n.length; h++) {
            var x = n[h];
            br(x) && Gr(x, l);
          }
        else if (br(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var P = Z(n);
          if (typeof P == "function" && P !== n.entries)
            for (var O = P.call(n), j; !(j = O.next()).done; )
              br(j.value) && Gr(j.value, l);
        }
      }
    }
    function en(n) {
      {
        var l = n.type;
        if (l == null || typeof l == "string")
          return;
        var h;
        if (typeof l == "function")
          h = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === b))
          h = l.propTypes;
        else
          return;
        if (h) {
          var x = Y(l);
          vr(h, n.props, "prop", x, n);
        } else if (l.PropTypes !== void 0 && !yr) {
          yr = !0;
          var P = Y(l);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rn(n) {
      {
        for (var l = Object.keys(n.props), h = 0; h < l.length; h++) {
          var x = l[h];
          if (x !== "children" && x !== "key") {
            Te(n), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", x), Te(null);
            break;
          }
        }
        n.ref !== null && (Te(n), $("Invalid attribute `ref` supplied to `React.Fragment`."), Te(null));
      }
    }
    function Yr(n, l, h, x, P, O) {
      {
        var j = fr(n);
        if (!j) {
          var _ = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var B = Xt(P);
          B ? _ += B : _ += zr();
          var M;
          n === null ? M = "null" : Le(n) ? M = "array" : n !== void 0 && n.$$typeof === t ? (M = "<" + (Y(n.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : M = typeof n, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, _);
        }
        var N = Kt(n, l, h, P, O);
        if (N == null)
          return N;
        if (j) {
          var J = l.children;
          if (J !== void 0)
            if (x)
              if (Le(J)) {
                for (var _e = 0; _e < J.length; _e++)
                  Hr(J[_e], n);
                Object.freeze && Object.freeze(J);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Hr(J, n);
        }
        return n === a ? rn(N) : en(N), N;
      }
    }
    function tn(n, l, h) {
      return Yr(n, l, h, !0);
    }
    function nn(n, l, h) {
      return Yr(n, l, h, !1);
    }
    var an = nn, on = tn;
    Be.Fragment = a, Be.jsx = an, Be.jsxs = on;
  }()), Be;
}
process.env.NODE_ENV === "production" ? Ir.exports = oa() : Ir.exports = ia();
var f = Ir.exports, sa = /* @__PURE__ */ mn({});
const At = sa;
function ar() {
  return ar = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ar.apply(this, arguments);
}
function ca(e) {
  if (Array.isArray(e))
    return e;
}
function ua(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var a, s, c, d, m = [], v = !0, R = !1;
    try {
      if (c = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        v = !1;
      } else
        for (; !(v = (a = c.call(r)).done) && (m.push(a.value), m.length !== t); v = !0)
          ;
    } catch (E) {
      R = !0, s = E;
    } finally {
      try {
        if (!v && r.return != null && (d = r.return(), Object(d) !== d))
          return;
      } finally {
        if (R)
          throw s;
      }
    }
    return m;
  }
}
function ot(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = e[r];
  return a;
}
function la(e, t) {
  if (e) {
    if (typeof e == "string")
      return ot(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ot(e, t);
  }
}
function fa() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mt(e, t) {
  return ca(e) || ua(e, t) || la(e, t) || fa();
}
function be(e) {
  "@babel/helpers - typeof";
  return be = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, be(e);
}
function da(e, t) {
  if (be(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(e, t || "default");
    if (be(a) != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pa(e) {
  var t = da(e, "string");
  return be(t) == "symbol" ? t : String(t);
}
function Ar(e, t, r) {
  return t = pa(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ma(e, t) {
  if (e == null)
    return {};
  var r = {}, a = Object.keys(e), s, c;
  for (c = 0; c < a.length; c++)
    s = a[c], !(t.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Ft(e, t) {
  if (e == null)
    return {};
  var r = ma(e, t), a, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (s = 0; s < c.length; s++)
      a = c[s], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (r[a] = e[a]);
  }
  return r;
}
var Dt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var c = "", d = 0; d < arguments.length; d++) {
        var m = arguments[d];
        m && (c = s(c, a(m)));
      }
      return c;
    }
    function a(c) {
      if (typeof c == "string" || typeof c == "number")
        return c;
      if (typeof c != "object")
        return "";
      if (Array.isArray(c))
        return r.apply(null, c);
      if (c.toString !== Object.prototype.toString && !c.toString.toString().includes("[native code]"))
        return c.toString();
      var d = "";
      for (var m in c)
        t.call(c, m) && c[m] && (d = s(d, m));
      return d;
    }
    function s(c, d) {
      return d ? c ? c + " " + d : c + d : c;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Dt);
var va = Dt.exports;
const ha = /* @__PURE__ */ aa(va);
function K(e, t) {
  ga(e) && (e = "100%");
  var r = ya(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function ga(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function ya(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function ba(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ze(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function wr(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function xa(e, t, r) {
  return {
    r: K(e, 255) * 255,
    g: K(t, 255) * 255,
    b: K(r, 255) * 255
  };
}
function Rr(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * (6 * r) : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function wa(e, t, r) {
  var a, s, c;
  if (e = K(e, 360), t = K(t, 100), r = K(r, 100), t === 0)
    s = r, c = r, a = r;
  else {
    var d = r < 0.5 ? r * (1 + t) : r + t - r * t, m = 2 * r - d;
    a = Rr(m, d, e + 1 / 3), s = Rr(m, d, e), c = Rr(m, d, e - 1 / 3);
  }
  return { r: a * 255, g: s * 255, b: c * 255 };
}
function Ra(e, t, r) {
  e = K(e, 255), t = K(t, 255), r = K(r, 255);
  var a = Math.max(e, t, r), s = Math.min(e, t, r), c = 0, d = a, m = a - s, v = a === 0 ? 0 : m / a;
  if (a === s)
    c = 0;
  else {
    switch (a) {
      case e:
        c = (t - r) / m + (t < r ? 6 : 0);
        break;
      case t:
        c = (r - e) / m + 2;
        break;
      case r:
        c = (e - t) / m + 4;
        break;
    }
    c /= 6;
  }
  return { h: c, s: v, v: d };
}
function Ea(e, t, r) {
  e = K(e, 360) * 6, t = K(t, 100), r = K(r, 100);
  var a = Math.floor(e), s = e - a, c = r * (1 - t), d = r * (1 - s * t), m = r * (1 - (1 - s) * t), v = a % 6, R = [r, d, c, c, m, r][v], E = [m, r, r, d, c, c][v], b = [c, c, m, r, r, d][v];
  return { r: R * 255, g: E * 255, b: b * 255 };
}
function Ta(e, t, r, a) {
  var s = [
    wr(Math.round(e).toString(16)),
    wr(Math.round(t).toString(16)),
    wr(Math.round(r).toString(16))
  ];
  return a && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) : s.join("");
}
function it(e) {
  return q(e) / 255;
}
function q(e) {
  return parseInt(e, 16);
}
var st = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function We(e) {
  var t = { r: 0, g: 0, b: 0 }, r = 1, a = null, s = null, c = null, d = !1, m = !1;
  return typeof e == "string" && (e = Sa(e)), typeof e == "object" && (oe(e.r) && oe(e.g) && oe(e.b) ? (t = xa(e.r, e.g, e.b), d = !0, m = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : oe(e.h) && oe(e.s) && oe(e.v) ? (a = Ze(e.s), s = Ze(e.v), t = Ea(e.h, a, s), d = !0, m = "hsv") : oe(e.h) && oe(e.s) && oe(e.l) && (a = Ze(e.s), c = Ze(e.l), t = wa(e.h, a, c), d = !0, m = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (r = e.a)), r = ba(r), {
    ok: d,
    format: e.format || m,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
var _a = "[-\\+]?\\d+%?", Ca = "[-\\+]?\\d*\\.\\d+%?", fe = "(?:".concat(Ca, ")|(?:").concat(_a, ")"), Er = "[\\s|\\(]+(".concat(fe, ")[,|\\s]+(").concat(fe, ")[,|\\s]+(").concat(fe, ")\\s*\\)?"), Tr = "[\\s|\\(]+(".concat(fe, ")[,|\\s]+(").concat(fe, ")[,|\\s]+(").concat(fe, ")[,|\\s]+(").concat(fe, ")\\s*\\)?"), re = {
  CSS_UNIT: new RegExp(fe),
  rgb: new RegExp("rgb" + Er),
  rgba: new RegExp("rgba" + Tr),
  hsl: new RegExp("hsl" + Er),
  hsla: new RegExp("hsla" + Tr),
  hsv: new RegExp("hsv" + Er),
  hsva: new RegExp("hsva" + Tr),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Sa(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (st[e])
    e = st[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var r = re.rgb.exec(e);
  return r ? { r: r[1], g: r[2], b: r[3] } : (r = re.rgba.exec(e), r ? { r: r[1], g: r[2], b: r[3], a: r[4] } : (r = re.hsl.exec(e), r ? { h: r[1], s: r[2], l: r[3] } : (r = re.hsla.exec(e), r ? { h: r[1], s: r[2], l: r[3], a: r[4] } : (r = re.hsv.exec(e), r ? { h: r[1], s: r[2], v: r[3] } : (r = re.hsva.exec(e), r ? { h: r[1], s: r[2], v: r[3], a: r[4] } : (r = re.hex8.exec(e), r ? {
    r: q(r[1]),
    g: q(r[2]),
    b: q(r[3]),
    a: it(r[4]),
    format: t ? "name" : "hex8"
  } : (r = re.hex6.exec(e), r ? {
    r: q(r[1]),
    g: q(r[2]),
    b: q(r[3]),
    format: t ? "name" : "hex"
  } : (r = re.hex4.exec(e), r ? {
    r: q(r[1] + r[1]),
    g: q(r[2] + r[2]),
    b: q(r[3] + r[3]),
    a: it(r[4] + r[4]),
    format: t ? "name" : "hex8"
  } : (r = re.hex3.exec(e), r ? {
    r: q(r[1] + r[1]),
    g: q(r[2] + r[2]),
    b: q(r[3] + r[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function oe(e) {
  return !!re.CSS_UNIT.exec(String(e));
}
var er = 2, ct = 0.16, ja = 0.05, Pa = 0.05, ka = 0.15, Nt = 5, $t = 4, Oa = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function ut(e) {
  var t = e.r, r = e.g, a = e.b, s = Ra(t, r, a);
  return {
    h: s.h * 360,
    s: s.s,
    v: s.v
  };
}
function rr(e) {
  var t = e.r, r = e.g, a = e.b;
  return "#".concat(Ta(t, r, a, !1));
}
function Ia(e, t, r) {
  var a = r / 100, s = {
    r: (t.r - e.r) * a + e.r,
    g: (t.g - e.g) * a + e.g,
    b: (t.b - e.b) * a + e.b
  };
  return s;
}
function lt(e, t, r) {
  var a;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? a = r ? Math.round(e.h) - er * t : Math.round(e.h) + er * t : a = r ? Math.round(e.h) + er * t : Math.round(e.h) - er * t, a < 0 ? a += 360 : a >= 360 && (a -= 360), a;
}
function ft(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var a;
  return r ? a = e.s - ct * t : t === $t ? a = e.s + ct : a = e.s + ja * t, a > 1 && (a = 1), r && t === Nt && a > 0.1 && (a = 0.1), a < 0.06 && (a = 0.06), Number(a.toFixed(2));
}
function dt(e, t, r) {
  var a;
  return r ? a = e.v + Pa * t : a = e.v - ka * t, a > 1 && (a = 1), Number(a.toFixed(2));
}
function Mr(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], a = We(e), s = Nt; s > 0; s -= 1) {
    var c = ut(a), d = rr(We({
      h: lt(c, s, !0),
      s: ft(c, s, !0),
      v: dt(c, s, !0)
    }));
    r.push(d);
  }
  r.push(rr(a));
  for (var m = 1; m <= $t; m += 1) {
    var v = ut(a), R = rr(We({
      h: lt(v, m),
      s: ft(v, m),
      v: dt(v, m)
    }));
    r.push(R);
  }
  return t.theme === "dark" ? Oa.map(function(E) {
    var b = E.index, k = E.opacity, A = rr(Ia(We(t.backgroundColor || "#141414"), We(r[b]), k * 100));
    return A;
  }) : r;
}
var _r = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, tr = {}, Cr = {};
Object.keys(_r).forEach(function(e) {
  tr[e] = Mr(_r[e]), tr[e].primary = tr[e][5], Cr[e] = Mr(_r[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), Cr[e].primary = Cr[e][5];
});
var Aa = tr.blue;
function pt(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pt(Object(r), !0).forEach(function(a) {
      Ar(e, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pt(Object(r)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return e;
}
function Ma() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Fa(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var mt = "data-rc-order", vt = "data-rc-priority", Da = "rc-util-key", Fr = /* @__PURE__ */ new Map();
function Lt() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : Da;
}
function Ur(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Na(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Ut(e) {
  return Array.from((Fr.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function Vt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Ma())
    return null;
  var r = t.csp, a = t.prepend, s = t.priority, c = s === void 0 ? 0 : s, d = Na(a), m = d === "prependQueue", v = document.createElement("style");
  v.setAttribute(mt, d), m && c && v.setAttribute(vt, "".concat(c)), r != null && r.nonce && (v.nonce = r?.nonce), v.innerHTML = e;
  var R = Ur(t), E = R.firstChild;
  if (a) {
    if (m) {
      var b = Ut(R).filter(function(k) {
        if (!["prepend", "prependQueue"].includes(k.getAttribute(mt)))
          return !1;
        var A = Number(k.getAttribute(vt) || 0);
        return c >= A;
      });
      if (b.length)
        return R.insertBefore(v, b[b.length - 1].nextSibling), v;
    }
    R.insertBefore(v, E);
  } else
    R.appendChild(v);
  return v;
}
function $a(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = Ur(t);
  return Ut(r).find(function(a) {
    return a.getAttribute(Lt(t)) === e;
  });
}
function La(e, t) {
  var r = Fr.get(e);
  if (!r || !Fa(document, r)) {
    var a = Vt("", t), s = a.parentNode;
    Fr.set(e, s), e.removeChild(a);
  }
}
function Ua(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = Ur(r);
  La(a, r);
  var s = $a(t, r);
  if (s) {
    var c, d;
    if ((c = r.csp) !== null && c !== void 0 && c.nonce && s.nonce !== ((d = r.csp) === null || d === void 0 ? void 0 : d.nonce)) {
      var m;
      s.nonce = (m = r.csp) === null || m === void 0 ? void 0 : m.nonce;
    }
    return s.innerHTML !== e && (s.innerHTML = e), s;
  }
  var v = Vt(e, r);
  return v.setAttribute(Lt(r), t), v;
}
function Bt(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function Va(e) {
  return Bt(e) instanceof ShadowRoot;
}
function Ba(e) {
  return Va(e) ? Bt(e) : null;
}
var Dr = {}, Vr = [], Wa = function(t) {
  Vr.push(t);
};
function za(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Vr.reduce(function(a, s) {
      return s(a ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function qa(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Vr.reduce(function(a, s) {
      return s(a ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function Ga() {
  Dr = {};
}
function Wt(e, t, r) {
  !t && !Dr[r] && (e(!1, r), Dr[r] = !0);
}
function or(e, t) {
  Wt(za, e, t);
}
function Ha(e, t) {
  Wt(qa, e, t);
}
or.preMessage = Wa;
or.resetWarned = Ga;
or.noteOnce = Ha;
function Ya(e) {
  return e.replace(/-(.)/g, function(t, r) {
    return r.toUpperCase();
  });
}
function Ja(e, t) {
  or(e, "[@ant-design/icons] ".concat(t));
}
function ht(e) {
  return be(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (be(e.icon) === "object" || typeof e.icon == "function");
}
function gt() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, r) {
    var a = e[r];
    switch (r) {
      case "class":
        t.className = a, delete t.class;
        break;
      default:
        delete t[r], t[Ya(r)] = a;
    }
    return t;
  }, {});
}
function Nr(e, t, r) {
  return r ? /* @__PURE__ */ L.createElement(e.tag, de(de({
    key: t
  }, gt(e.attrs)), r), (e.children || []).map(function(a, s) {
    return Nr(a, "".concat(t, "-").concat(e.tag, "-").concat(s));
  })) : /* @__PURE__ */ L.createElement(e.tag, de({
    key: t
  }, gt(e.attrs)), (e.children || []).map(function(a, s) {
    return Nr(a, "".concat(t, "-").concat(e.tag, "-").concat(s));
  }));
}
function zt(e) {
  return Mr(e)[0];
}
function qt(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Qa = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Ka = function(t) {
  var r = vn(At), a = r.csp, s = r.prefixCls, c = Qa;
  s && (c = c.replace(/anticon/g, s)), hn(function() {
    var d = t.current, m = Ba(d);
    Ua(c, "@ant-design-icons", {
      prepend: !0,
      csp: a,
      attachTo: m
    });
  }, []);
}, Xa = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], qe = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Za(e) {
  var t = e.primaryColor, r = e.secondaryColor;
  qe.primaryColor = t, qe.secondaryColor = r || zt(t), qe.calculated = !!r;
}
function eo() {
  return de({}, qe);
}
var ir = function(t) {
  var r = t.icon, a = t.className, s = t.onClick, c = t.style, d = t.primaryColor, m = t.secondaryColor, v = Ft(t, Xa), R = ge.useRef(), E = qe;
  if (d && (E = {
    primaryColor: d,
    secondaryColor: m || zt(d)
  }), Ka(R), Ja(ht(r), "icon should be icon definiton, but got ".concat(r)), !ht(r))
    return null;
  var b = r;
  return b && typeof b.icon == "function" && (b = de(de({}, b), {}, {
    icon: b.icon(E.primaryColor, E.secondaryColor)
  })), Nr(b.icon, "svg-".concat(b.name), de(de({
    className: a,
    onClick: s,
    style: c,
    "data-icon": b.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, v), {}, {
    ref: R
  }));
};
ir.displayName = "IconReact";
ir.getTwoToneColors = eo;
ir.setTwoToneColors = Za;
const Br = ir;
function Gt(e) {
  var t = qt(e), r = Mt(t, 2), a = r[0], s = r[1];
  return Br.setTwoToneColors({
    primaryColor: a,
    secondaryColor: s
  });
}
function ro() {
  var e = Br.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var to = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Gt(Aa.primary);
var sr = /* @__PURE__ */ ge.forwardRef(function(e, t) {
  var r, a = e.className, s = e.icon, c = e.spin, d = e.rotate, m = e.tabIndex, v = e.onClick, R = e.twoToneColor, E = Ft(e, to), b = ge.useContext(At), k = b.prefixCls, A = k === void 0 ? "anticon" : k, G = b.rootClassName, V = ha(G, A, (r = {}, Ar(r, "".concat(A, "-").concat(s.name), !!s.name), Ar(r, "".concat(A, "-spin"), !!c || s.name === "loading"), r), a), Z = m;
  Z === void 0 && v && (Z = -1);
  var H = d ? {
    msTransform: "rotate(".concat(d, "deg)"),
    transform: "rotate(".concat(d, "deg)")
  } : void 0, $ = qt(R), xe = Mt($, 2), Pe = xe[0], ke = xe[1];
  return /* @__PURE__ */ ge.createElement("span", ar({
    role: "img",
    "aria-label": s.name
  }, E, {
    ref: t,
    tabIndex: Z,
    onClick: v,
    className: V
  }), /* @__PURE__ */ ge.createElement(Br, {
    icon: s,
    primaryColor: Pe,
    secondaryColor: ke,
    style: H
  }));
});
sr.displayName = "AntdIcon";
sr.getTwoToneColor = ro;
sr.setTwoToneColor = Gt;
const no = sr;
var ao = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const oo = ao;
var Ht = function(t, r) {
  return /* @__PURE__ */ ge.createElement(no, ar({}, t, {
    ref: r,
    icon: oo
  }));
};
process.env.NODE_ENV !== "production" && (Ht.displayName = "LoadingOutlined");
const Yt = /* @__PURE__ */ ge.forwardRef(Ht), io = {
  getAll: async () => (await ve().get(Gn)).data.Result
}, so = () => Ge({
  queryKey: [In],
  queryFn: pe.getAll
}), co = (e, t) => Ge({
  retry: 1,
  enabled: !!e,
  refetchOnWindowFocus: !1,
  queryKey: [kn, e],
  queryFn: () => pe.generate(e, t)
}), uo = (e) => Ge({
  queryFn: () => pe.getByProc?.(e),
  queryKey: [Mn, e]
}), lo = (e, t) => Ge({
  retry: 1,
  enabled: !!e,
  refetchOnWindowFocus: !1,
  queryKey: [On, e],
  queryFn: () => pe.generateTicket(t)
}), fo = () => Ge({
  queryKey: [An],
  queryFn: io.getAll
}), po = () => {
  let e;
  return St({
    mutationKey: ["VerifyService"],
    mutationFn: pe.verifyService,
    onMutate: () => {
      e = he.loading("Verificando servicio");
    },
    onSuccess: () => {
      he.dismiss(e), he("El servicio ha sido verificado correctamente", {
        icon: "🖨️"
      });
    },
    onError: () => {
      he.dismiss(e), he.error("El servicio de impresión se encuentra detenido o no esta instalado en su equipo");
    }
  });
}, mo = () => St({
  mutationFn: pe.print,
  mutationKey: ["PrintTicket"]
}), vo = () => {
  const { reportName: e } = wt(), { token: t } = bt.useToken(), [r] = Rt(), { refetch: a, isError: s, isPending: c, data: d, failureReason: m } = co(`${e}`, Object.fromEntries([...r])), v = L.useCallback(async () => {
    const b = document.createElement("a");
    b.href = `data:application/pdf;base64,${d ?? ""}`, b.download = `${e}`, b.click();
  }, [d, e]);
  function R(b) {
    const k = window.atob(b), A = k.length, G = new Uint8Array(A);
    for (let V = 0; V < A; V++) {
      const Z = k.charCodeAt(V);
      G[V] = Z;
    }
    return G;
  }
  const E = L.useCallback(() => {
    const b = R(d ?? ""), k = new Blob([b], { type: "application/pdf" });
    window.open(URL.createObjectURL(k), "_blank");
  }, [d]);
  return c ? f.jsx(ie, { children: f.jsx(ye, { title: "El reporte esta siendo generado...", icon: f.jsx(Yt, { style: { fontSize: 150 } }), subTitle: "Por favor espere mientras el servidor genera el reporte solicitado." }) }) : s && !d ? f.jsx(ie, { children: f.jsx(ye, { status: "error", style: { padding: 0 }, icon: f.jsx(Tt, { width: 200 }), title: "Hubo un error al generar el reporte solicitado", subTitle: "Por favor, verifique los posibles errores e inténtelo de nuevo.", extra: [
    f.jsx(U, { style: { gap: 8, flexWrap: "wrap", justifyContent: "center" }, children: f.jsx(ze, { size: "large", onClick: () => a(), renderLeftIcon: f.jsx(Q, { size: 22, name: "refresh" }), children: "Intentarlo nuevamente" }) }, "error-extra")
  ], children: f.jsxs(U, { style: { alignSelf: "center", flexDirection: "column" }, children: [f.jsx(_t, { children: f.jsx(jr, { strong: !0, style: { fontSize: 16 }, children: "Posibles errores:" }) }), f.jsxs(U, { style: { gap: 10, flexDirection: "column" }, children: [f.jsx(Ce, { size: 16, icon: f.jsx(Q, { size: 20, name: "circle-x" }), text: "Los parámetros especificados son incorrectos." }), f.jsx(Ce, { size: 16, icon: f.jsx(Q, { size: 20, name: "circle-x" }), text: "Los valores o identificadores son incorrectos." }), m && f.jsx(Ce, { text: `${m}`, icon: f.jsx(Q, { name: "bug", color: t.red6 }), textProps: { style: { fontSize: 16, color: t.red6 } } })] })] }) }) }) : f.jsx(f.Fragment, { children: f.jsx(ie, { children: f.jsx(ye, { status: "success", icon: f.jsx(Ct, { width: 200 }), title: "¡El reporte ha sido generado correctamente!", subTitle: "Seleccione a continuación su método preferido para visualizar el reporte", extra: [
    f.jsxs(U, { style: { gap: 8, flexWrap: "wrap", justifyContent: "center" }, children: [f.jsx(ze, { size: "large", type: "primary", onClick: E, renderLeftIcon: f.jsx(Q, { size: 20, name: "eye" }), children: "Ver en línea" }, "view"), f.jsx(ze, { size: "large", onClick: v, renderLeftIcon: f.jsx(Q, { size: 20, name: "download" }), children: "Descargar" }, "download")] }, "success-extra")
  ] }) }) });
}, Se = X.device.mobileS, je = X.maxDevice.tablet;
W(U)`
    flex: 1;
    flex-direction: column;

    @media ${X.device.mobileS} {
        flex-direction: column;
    }

    @media screen and (${X.device.laptop}) {
        flex-direction: column;
        height: 100%;
    }
`;
const ho = W(gn)``;
W(ie)`
    display: flex;
    padding: 10px 24px;
    border-bottom: 1.8px solid lightgrey;
    align-items: center;
    gap: 15px;
    justify-content: space-between;

    ${ho} {
        align-self: center;
    }

    @media only screen and (${Se}) and (${je}) {
        border-right: 0;
        overflow: unset;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
    }
`;
W(yn)`
    display: flex;
    padding: 10px;
    width: 50%;

    @media only screen and (${Se}) and (${je}) {
        width: 100%;
    }
`;
W(U)`
    flex: 1;
    flex-direction: row;
    gap: 20px;
    overflow: hidden;

    @media ${X.device.mobileS} {
        flex-direction: column;
    }

    @media ${X.device.tablet} {
        flex-direction: row;
    }
`;
const go = W(bn)``;
W(U)`
    flex-direction: row;
    align-items: center;

    ${go} {
        margin: 0px 20px;
        height: 50px;

        @media only screen and (${Se}) and (${je}) {
            display: none;
        }
    }

    @media only screen and (${Se}) and (${je}) {
        flex-direction: column;
    }
`;
W(U)`
    flex: 1;
    margin: 20px 0px 20px 20px;
    flex-direction: column;
    justify-content: center;

    @media only screen and (${Se}) and (${je}) {
        display: none !important;
    }
`;
W(xn)`
    display: flex;
    flex: 3.5;
    height: 100%;
    flex-direction: column;
    padding: 20px 20px 20px 0px;
    overflow: auto;

    @media only screen and (${Se}) and (${je}) {
        padding: 20px;
    }
`;
W(U)`
    flex: 1;
    height: 100%;
    align-items: center;
    justify-content: center;
`;
W(wn)`
    background-color: ${({ theme: e }) => e.colors?.primary500};
`;
const yo = ({ data: e }) => {
  const t = L.useMemo(() => e.ReporteParametroOpcion?.split(`
`).reduce((s, c) => {
    if (!c)
      return s;
    const d = c?.split(",") ?? [];
    return [
      ...s,
      { label: d[1], value: parseInt(d[0]) }
    ];
  }, []), [e.ReporteParametroOpcion]), r = L.useMemo(() => ({
    name: e.ReporteParametroCampo,
    label: e.ReporteParametroNombre,
    tooltip: `${e.ReporteParametroDescripcion}`,
    rules: {
      required: e.ReporteParametroRequerido ? "Campo requerido" : void 0
    }
  }), [
    e.ReporteParametroCampo,
    e.ReporteParametroDescripcion,
    e.ReporteParametroNombre,
    e.ReporteParametroRequerido
  ]);
  return L.useMemo(() => ({
    [Vn]: f.jsx(_n, { placeholder: "Ingrese una fecha", ...r }),
    [Ln]: f.jsx(Cn, { placeholder: "Ingresa un numero", ...r }),
    [$n]: f.jsx(Sn, { ...r, type: "text", placeholder: "Escribe un texto" }),
    [Bn]: f.jsx(Or, { ...r, options: t, placeholder: "Selecciona una opción" }),
    [Un]: f.jsx(jn, { ...r, size: "large", defaultValue: "False", options: [
      { value: "True", label: "Habilitar" },
      { value: "False", label: "Deshabilitar" }
    ] })
  }), [r, t])[e.ReporteParametroTipoId] ?? "[Este tipo de parámetro no esta siendo manejado]";
}, bo = W(U)`
  flex: 1;
  flex-direction: column;
  gap: 10;

  @media ${X.minDevice.mobileS && X.maxDevice.tablet} {
    max-width: 280px;
    flex-direction: column;
  }
`, xo = W(U)`
  padding-top: 10px;
  gap: 15px;

  @media ${X.minDevice.mobileS && X.maxDevice.tablet} {
    max-width: 270px;
    flex-direction: column;
  }
`, Jt = ({ onSubmit: e, isPending: t, renderContent: r }) => {
  const a = Pn({ mode: "all", reValidateMode: "onChange" });
  return f.jsx(bo, { children: f.jsxs(xr, { methods: a, initialConfig: { inputSize: "large" }, formProps: { layout: "vertical", requiredMark: !0 }, children: [f.jsx(nr, { hideSectionTitles: !0, columnsByRows: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
    xl: 2,
    xxl: 3
  }, children: jt.renderLoader(t, f.jsxs(nr.Section, { section: "Skeletons", children: [f.jsx(Pr, { count: 2, height: 40 }), f.jsx(Pr, { count: 2, height: 40 })] }))(r(a)) }), f.jsxs(xo, { children: [f.jsx(xr.SubmitButton, { onClick: a.handleSubmit((s) => e(un(s, (c, d) => Xr.isDayjs(d) ? [c, Xr(d).format("DD/MM/YYYY")] : [c, d]), a)), children: "Generar reporte" }), f.jsx(xr.ResetButton, { children: "Reiniciar formulario" })] })] }) });
}, wo = ({ reportId: e }) => {
  const t = Et(), r = uo(e);
  return f.jsx(Jt, { isPending: r.isPending, renderContent: () => f.jsx(nr.Section, { section: "ReportsForm", children: (r?.data?.ReportesParametros ?? []).map((a) => f.jsx(yo, { data: a }, a.ReporteParametroCampo)) }), onSubmit: (a) => {
    if (!r.data) {
      he.error("Hubo un error al cargar los datos...");
      return;
    }
    const s = Lr(r.data.ReporteArchivoNombre, a, r.data.ReporteTipoId === $r ? "ticket" : "pdf");
    t(s);
  } });
}, Ro = ({ ReporteTipoId: e, ReporteArchivoNombre: t }) => {
  const r = Et(), a = kr.useFetchProvinces(), [s, c] = L.useState(0), d = kr.useFetchMunicipalitiesByProvince(s ?? 0), m = L.useMemo(() => a.data?.length ? Zr.selectLabelValue(a.data ?? [], "PaisProvinciaNombre", "PaisProvinciaId") : [], [a.data]), v = L.useMemo(() => d.data?.length ? Zr.selectLabelValue(d.data ?? [], "PaisProvinciaMunicipioNombre", "PaisProvinciaMunicipioId") : [], [d.data]);
  return f.jsx(Jt, { isPending: !1, onSubmit: (R) => {
    const E = Lr(t, R, e === $r ? "ticket" : "pdf");
    r(E);
  }, renderContent: (R) => f.jsxs(nr.Section, { section: "ReportForm", children: [f.jsx(Or, { name: "ProvinciaId", label: "Provincias", options: m, loading: a.isPending, rules: { required: "error_required" }, placeholder: "Selecciona una provincia", onChange: (E) => {
    c(E), R.resetField("MunicipioId");
  } }), f.jsx(Or, { name: "MunicipioId", label: "Municipios", disabled: !s, options: v, loading: d.isPending, placeholder: "Selecciona un municipio", rules: { required: "error_required" } })] }) });
}, Eo = W(U)`
  flex: 1;
  gap: 20px;
  height: 100%;

  @media ${X.minDevice.mobileS && X.maxDevice.tablet} {
    flex-direction: column;
  }
`, To = [
  {
    EstadoId: 1,
    ReporteId: 36,
    ReporteTipoId: 2,
    ReporteCategoriaId: 4,
    element: Ro,
    ReporteNombre: "Clientes por Municipios",
    ReporteArchivoNombre: "ClientesMunicipio"
  }
], _o = () => {
  const e = so(), t = fo(), [r, a] = L.useState(null), s = L.useCallback(() => f.jsx(ie, { children: f.jsx(ye, { icon: f.jsx(Rn, { width: 200 }), title: "Aún no se ha seleccionado ningún reporte", subTitle: "Por favor, seleccione un reporte para generar." }) }), []), c = L.useCallback((m, v = !0) => {
    if (!m)
      return null;
    const R = {
      [$r]: "receipt",
      [Nn]: "pdf",
      [Dn]: "pdf",
      [Fn]: "pdf"
    };
    return f.jsx(Q, { touchable: v, name: R[m] });
  }, []), d = L.useMemo(() => {
    if (!e?.data?.length || !t.data?.length)
      return [];
    const m = ln(e.data ?? [], To, (v) => v.ReporteId);
    return Sr(t.data, (v, R) => {
      const E = Sr(m, (b) => ({
        label: b.ReporteNombre,
        icon: c(b.ReporteTipoId),
        key: `Category-${v.ReporteCategoriaId}-Reporte-${b.ReporteId}`,
        onClick: Tn.callEvent(a, b)
      }), (b) => b.ReporteCategoriaId === v.ReporteCategoriaId);
      return {
        label: v.ReporteCategoriaNombre,
        key: `Category-${v.ReporteCategoriaId}`,
        children: E.length ? E : [
          {
            disabled: !0,
            key: `Category-${R}-NoReports`,
            label: "Esta categoría no contiene reportes"
          }
        ]
      };
    }, (v) => v.EstadoId === En.ACTIVE_CODE);
  }, [t.data, c, e.data]);
  return f.jsxs(Eo, { children: [f.jsx(Kr, { title: "Lista de categorías", bodyStyle: { padding: "1px 0 0 0" }, style: { flex: 1, overflow: "auto" }, children: jt.renderLoader(t.isPending || e.isPending, f.jsx(ie, { style: { padding: "10px 10px" }, children: f.jsx(Pr, { count: 6, height: 40 }) }))(f.jsx(sn, { mode: "inline", items: d ?? [] })) }), f.jsx(Kr, { style: { flex: 3 }, title: r?.ReporteNombre ?? "", extra: c(r?.ReporteTipoId ?? 0, !1), children: r !== null ? f.jsx(f.Fragment, { children: r?.element ? f.jsx(r.element, { ...r }) : f.jsx(wo, { reportId: r.ReporteId }, `ReportForm-${r.ReporteId}`) }) : s() })] });
}, Co = () => {
  const { reportName: e } = wt(), { token: t } = bt.useToken(), r = po(), a = mo(), s = kr.useFetchOneGeneralSettingByTag("ImpresoraTicket"), [c, d] = xt.useModal(), [m] = Rt(), v = L.useMemo(() => ({
    okText: "Descargar",
    title: "No se ha encontrado el servicio de Impresión",
    onOk: () => {
      window.open("https://app.sistema.com.do/installer.zip", "_blank");
    },
    content: f.jsx(jr, { children: "No tiene instalado el servicio de impresión. Haga click en descargar para instalarlo" })
  }), []), { refetch: R, isError: E, isPending: b, isFetching: k, data: A, failureReason: G } = lo(`${e}`, Object.fromEntries([...m])), V = L.useCallback(async () => {
    try {
      await r.mutateAsync() ? await he.promise(a.mutateAsync({
        data: A?.formato ?? "",
        printer: s.data?.Valor ?? ""
      }), {
        error: (H) => H,
        success: "Ticket enviado correctamente",
        loading: "Enviando ticket a la impresora"
      }) : c.error(v);
    } catch {
      c.error(v);
    }
  }, [v, c, a, s.data?.Valor, A, r]);
  return b || k ? f.jsx(ie, { children: f.jsx(ye, { title: "El ticket esta siendo generado...", icon: f.jsx(Yt, { style: { fontSize: 150 } }), subTitle: "Por favor espere mientras el servidor genera el ticket solicitado." }) }) : E && !A ? f.jsx(ie, { children: f.jsx(ye, { status: "error", style: { padding: 0 }, icon: f.jsx(Tt, { width: 200 }), title: "Hubo un error al generar el ticket solicitado", subTitle: "Por favor, verifique los posibles errores e inténtelo de nuevo.", extra: [
    f.jsx(U, { style: { gap: 8, flexWrap: "wrap", justifyContent: "center" }, children: f.jsx(ze, { size: "large", onClick: () => R(), renderLeftIcon: f.jsx(Q, { size: 22, name: "refresh" }), children: "Intentarlo nuevamente" }) }, "error-extra")
  ], children: f.jsxs(U, { style: { alignSelf: "center", flexDirection: "column" }, children: [f.jsx(_t, { children: f.jsx(jr, { strong: !0, style: { fontSize: 16 }, children: "Posibles errores:" }) }), f.jsxs(U, { style: { gap: 10, flexDirection: "column" }, children: [f.jsx(Ce, { size: 16, icon: f.jsx(Q, { size: 20, name: "circle-x" }), text: "Los parámetros especificados son incorrectos." }), f.jsx(Ce, { size: 16, icon: f.jsx(Q, { size: 20, name: "circle-x" }), text: "Los valores o identificadores son incorrectos." }), G && f.jsx(Ce, { text: `${G}`, icon: f.jsx(Q, { name: "bug", color: t.red6 }), textProps: { style: { fontSize: 16, color: t.red6 } } })] })] }) }) }) : f.jsxs(f.Fragment, { children: [d, f.jsx(ie, { children: f.jsx(ye, { status: "success", icon: f.jsx(Ct, { width: 200 }), title: "¡El ticket ha sido generado correctamente!", subTitle: "Seleccione a continuación su método preferido para visualizar el ticket", extra: [
    f.jsx(U, { style: { gap: 8, flexWrap: "wrap", justifyContent: "center" }, children: f.jsx(ze, { size: "large", loading: k, onClick: V, renderLeftIcon: f.jsx(Q, { name: "print" }), children: "Imprimir" }, "download") }, "success-extra")
  ] }) })] });
}, So = () => ({
  sidebar: !0,
  element: dn,
  title: "Reportes",
  iconName: "report",
  withMainLayout: !1,
  id: "reporting-module-root",
  path: Pt,
  children: [
    {
      path: "",
      index: !0,
      sidebar: !1,
      title: "Reportes",
      element: _o,
      id: "reporting-module-view"
    },
    {
      sidebar: !1,
      element: vo,
      id: "reporting-pdf-view",
      title: "Reporte PDF ({reportName})",
      path: kt
    },
    {
      sidebar: !1,
      element: Co,
      id: "reporting-ticket-view",
      title: "Reportes Ticket ({reportName})",
      path: Ot
    }
  ]
});
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var yt;
(function(e) {
  (function(t) {
    var r = typeof tt == "object" ? tt : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), a = s(e);
    typeof r.Reflect > "u" ? r.Reflect = e : a = s(r.Reflect, a), t(a);
    function s(c, d) {
      return function(m, v) {
        typeof c[m] != "function" && Object.defineProperty(c, m, { configurable: !0, writable: !0, value: v }), d && d(m, v);
      };
    }
  })(function(t) {
    var r = Object.prototype.hasOwnProperty, a = typeof Symbol == "function", s = a && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", c = a && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", d = typeof Object.create == "function", m = { __proto__: [] } instanceof Array, v = !d && !m, R = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: d ? function() {
        return Ue(/* @__PURE__ */ Object.create(null));
      } : m ? function() {
        return Ue({ __proto__: null });
      } : function() {
        return Ue({});
      },
      has: v ? function(o, i) {
        return r.call(o, i);
      } : function(o, i) {
        return i in o;
      },
      get: v ? function(o, i) {
        return r.call(o, i) ? o[i] : void 0;
      } : function(o, i) {
        return o[i];
      }
    }, E = Object.getPrototypeOf(Function), b = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", k = !b && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : vr(), A = !b && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : hr(), G = !b && typeof WeakMap == "function" ? WeakMap : Le(), V = new G();
    function Z(o, i, u, p) {
      if (I(u)) {
        if (!me(o))
          throw new TypeError();
        if (!$e(i))
          throw new TypeError();
        return fr(o, i);
      } else {
        if (!me(o))
          throw new TypeError();
        if (!F(i))
          throw new TypeError();
        if (!F(p) && !I(p) && !ne(p))
          throw new TypeError();
        return ne(p) && (p = void 0), u = z(u), dr(o, i, u, p);
      }
    }
    t("decorate", Z);
    function H(o, i) {
      function u(p, g) {
        if (!F(p))
          throw new TypeError();
        if (!I(g) && !mr(g))
          throw new TypeError();
        Ie(o, i, p, g);
      }
      return u;
    }
    t("metadata", H);
    function $(o, i, u, p) {
      if (!F(u))
        throw new TypeError();
      return I(p) || (p = z(p)), Ie(o, i, u, p);
    }
    t("defineMetadata", $);
    function xe(o, i, u) {
      if (!F(i))
        throw new TypeError();
      return I(u) || (u = z(u)), Y(o, i, u);
    }
    t("hasMetadata", xe);
    function Pe(o, i, u) {
      if (!F(i))
        throw new TypeError();
      return I(u) || (u = z(u)), ee(o, i, u);
    }
    t("hasOwnMetadata", Pe);
    function ke(o, i, u) {
      if (!F(i))
        throw new TypeError();
      return I(u) || (u = z(u)), ce(o, i, u);
    }
    t("getMetadata", ke);
    function cr(o, i, u) {
      if (!F(i))
        throw new TypeError();
      return I(u) || (u = z(u)), Oe(o, i, u);
    }
    t("getOwnMetadata", cr);
    function ur(o, i) {
      if (!F(o))
        throw new TypeError();
      return I(i) || (i = z(i)), Ae(o, i);
    }
    t("getMetadataKeys", ur);
    function lr(o, i) {
      if (!F(o))
        throw new TypeError();
      return I(i) || (i = z(i)), Me(o, i);
    }
    t("getOwnMetadataKeys", lr);
    function He(o, i, u) {
      if (!F(i))
        throw new TypeError();
      I(u) || (u = z(u));
      var p = se(
        i,
        u,
        /*Create*/
        !1
      );
      if (I(p) || !p.delete(o))
        return !1;
      if (p.size > 0)
        return !0;
      var g = V.get(i);
      return g.delete(u), g.size > 0 || V.delete(i), !0;
    }
    t("deleteMetadata", He);
    function fr(o, i) {
      for (var u = o.length - 1; u >= 0; --u) {
        var p = o[u], g = p(i);
        if (!I(g) && !ne(g)) {
          if (!$e(g))
            throw new TypeError();
          i = g;
        }
      }
      return i;
    }
    function dr(o, i, u, p) {
      for (var g = o.length - 1; g >= 0; --g) {
        var D = o[g], w = D(i, u, p);
        if (!I(w) && !ne(w)) {
          if (!F(w))
            throw new TypeError();
          p = w;
        }
      }
      return p;
    }
    function se(o, i, u) {
      var p = V.get(o);
      if (I(p)) {
        if (!u)
          return;
        p = new k(), V.set(o, p);
      }
      var g = p.get(i);
      if (I(g)) {
        if (!u)
          return;
        g = new k(), p.set(i, g);
      }
      return g;
    }
    function Y(o, i, u) {
      var p = ee(o, i, u);
      if (p)
        return !0;
      var g = le(i);
      return ne(g) ? !1 : Y(o, g, u);
    }
    function ee(o, i, u) {
      var p = se(
        i,
        u,
        /*Create*/
        !1
      );
      return I(p) ? !1 : Ne(p.has(o));
    }
    function ce(o, i, u) {
      var p = ee(o, i, u);
      if (p)
        return Oe(o, i, u);
      var g = le(i);
      if (!ne(g))
        return ce(o, g, u);
    }
    function Oe(o, i, u) {
      var p = se(
        i,
        u,
        /*Create*/
        !1
      );
      if (!I(p))
        return p.get(o);
    }
    function Ie(o, i, u, p) {
      var g = se(
        u,
        p,
        /*Create*/
        !0
      );
      g.set(o, i);
    }
    function Ae(o, i) {
      var u = Me(o, i), p = le(o);
      if (p === null)
        return u;
      var g = Ae(p, i);
      if (g.length <= 0)
        return u;
      if (u.length <= 0)
        return g;
      for (var D = new A(), w = [], T = 0, y = u; T < y.length; T++) {
        var C = y[T], S = D.has(C);
        S || (D.add(C), w.push(C));
      }
      for (var te = 0, Xe = g; te < Xe.length; te++) {
        var C = Xe[te], S = D.has(C);
        S || (D.add(C), w.push(C));
      }
      return w;
    }
    function Me(o, i) {
      var u = [], p = se(
        o,
        i,
        /*Create*/
        !1
      );
      if (I(p))
        return u;
      for (var g = p.keys(), D = Re(g), w = 0; ; ) {
        var T = Qe(D);
        if (!T)
          return u.length = w, u;
        var y = Ee(T);
        try {
          u[w] = y;
        } catch (C) {
          try {
            Ke(D);
          } finally {
            throw C;
          }
        }
        w++;
      }
    }
    function Fe(o) {
      if (o === null)
        return 1;
      switch (typeof o) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return o === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function I(o) {
      return o === void 0;
    }
    function ne(o) {
      return o === null;
    }
    function Ye(o) {
      return typeof o == "symbol";
    }
    function F(o) {
      return typeof o == "object" ? o !== null : typeof o == "function";
    }
    function pr(o, i) {
      switch (Fe(o)) {
        case 0:
          return o;
        case 1:
          return o;
        case 2:
          return o;
        case 3:
          return o;
        case 4:
          return o;
        case 5:
          return o;
      }
      var u = i === 3 ? "string" : i === 5 ? "number" : "default", p = Je(o, s);
      if (p !== void 0) {
        var g = p.call(o, u);
        if (F(g))
          throw new TypeError();
        return g;
      }
      return De(o, u === "default" ? "number" : u);
    }
    function De(o, i) {
      if (i === "string") {
        var u = o.toString;
        if (ue(u)) {
          var p = u.call(o);
          if (!F(p))
            return p;
        }
        var g = o.valueOf;
        if (ue(g)) {
          var p = g.call(o);
          if (!F(p))
            return p;
        }
      } else {
        var g = o.valueOf;
        if (ue(g)) {
          var p = g.call(o);
          if (!F(p))
            return p;
        }
        var D = o.toString;
        if (ue(D)) {
          var p = D.call(o);
          if (!F(p))
            return p;
        }
      }
      throw new TypeError();
    }
    function Ne(o) {
      return !!o;
    }
    function we(o) {
      return "" + o;
    }
    function z(o) {
      var i = pr(
        o,
        3
        /* String */
      );
      return Ye(i) ? i : we(i);
    }
    function me(o) {
      return Array.isArray ? Array.isArray(o) : o instanceof Object ? o instanceof Array : Object.prototype.toString.call(o) === "[object Array]";
    }
    function ue(o) {
      return typeof o == "function";
    }
    function $e(o) {
      return typeof o == "function";
    }
    function mr(o) {
      switch (Fe(o)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function Je(o, i) {
      var u = o[i];
      if (u != null) {
        if (!ue(u))
          throw new TypeError();
        return u;
      }
    }
    function Re(o) {
      var i = Je(o, c);
      if (!ue(i))
        throw new TypeError();
      var u = i.call(o);
      if (!F(u))
        throw new TypeError();
      return u;
    }
    function Ee(o) {
      return o.value;
    }
    function Qe(o) {
      var i = o.next();
      return i.done ? !1 : i;
    }
    function Ke(o) {
      var i = o.return;
      i && i.call(o);
    }
    function le(o) {
      var i = Object.getPrototypeOf(o);
      if (typeof o != "function" || o === E || i !== E)
        return i;
      var u = o.prototype, p = u && Object.getPrototypeOf(u);
      if (p == null || p === Object.prototype)
        return i;
      var g = p.constructor;
      return typeof g != "function" || g === o ? i : g;
    }
    function vr() {
      var o = {}, i = [], u = (
        /** @class */
        function() {
          function w(T, y, C) {
            this._index = 0, this._keys = T, this._values = y, this._selector = C;
          }
          return w.prototype["@@iterator"] = function() {
            return this;
          }, w.prototype[c] = function() {
            return this;
          }, w.prototype.next = function() {
            var T = this._index;
            if (T >= 0 && T < this._keys.length) {
              var y = this._selector(this._keys[T], this._values[T]);
              return T + 1 >= this._keys.length ? (this._index = -1, this._keys = i, this._values = i) : this._index++, { value: y, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, w.prototype.throw = function(T) {
            throw this._index >= 0 && (this._index = -1, this._keys = i, this._values = i), T;
          }, w.prototype.return = function(T) {
            return this._index >= 0 && (this._index = -1, this._keys = i, this._values = i), { value: T, done: !0 };
          }, w;
        }()
      );
      return (
        /** @class */
        function() {
          function w() {
            this._keys = [], this._values = [], this._cacheKey = o, this._cacheIndex = -2;
          }
          return Object.defineProperty(w.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), w.prototype.has = function(T) {
            return this._find(
              T,
              /*insert*/
              !1
            ) >= 0;
          }, w.prototype.get = function(T) {
            var y = this._find(
              T,
              /*insert*/
              !1
            );
            return y >= 0 ? this._values[y] : void 0;
          }, w.prototype.set = function(T, y) {
            var C = this._find(
              T,
              /*insert*/
              !0
            );
            return this._values[C] = y, this;
          }, w.prototype.delete = function(T) {
            var y = this._find(
              T,
              /*insert*/
              !1
            );
            if (y >= 0) {
              for (var C = this._keys.length, S = y + 1; S < C; S++)
                this._keys[S - 1] = this._keys[S], this._values[S - 1] = this._values[S];
              return this._keys.length--, this._values.length--, T === this._cacheKey && (this._cacheKey = o, this._cacheIndex = -2), !0;
            }
            return !1;
          }, w.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = o, this._cacheIndex = -2;
          }, w.prototype.keys = function() {
            return new u(this._keys, this._values, p);
          }, w.prototype.values = function() {
            return new u(this._keys, this._values, g);
          }, w.prototype.entries = function() {
            return new u(this._keys, this._values, D);
          }, w.prototype["@@iterator"] = function() {
            return this.entries();
          }, w.prototype[c] = function() {
            return this.entries();
          }, w.prototype._find = function(T, y) {
            return this._cacheKey !== T && (this._cacheIndex = this._keys.indexOf(this._cacheKey = T)), this._cacheIndex < 0 && y && (this._cacheIndex = this._keys.length, this._keys.push(T), this._values.push(void 0)), this._cacheIndex;
          }, w;
        }()
      );
      function p(w, T) {
        return w;
      }
      function g(w, T) {
        return T;
      }
      function D(w, T) {
        return [w, T];
      }
    }
    function hr() {
      return (
        /** @class */
        function() {
          function o() {
            this._map = new k();
          }
          return Object.defineProperty(o.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), o.prototype.has = function(i) {
            return this._map.has(i);
          }, o.prototype.add = function(i) {
            return this._map.set(i, i), this;
          }, o.prototype.delete = function(i) {
            return this._map.delete(i);
          }, o.prototype.clear = function() {
            this._map.clear();
          }, o.prototype.keys = function() {
            return this._map.keys();
          }, o.prototype.values = function() {
            return this._map.values();
          }, o.prototype.entries = function() {
            return this._map.entries();
          }, o.prototype["@@iterator"] = function() {
            return this.keys();
          }, o.prototype[c] = function() {
            return this.keys();
          }, o;
        }()
      );
    }
    function Le() {
      var o = 16, i = R.create(), u = p();
      return (
        /** @class */
        function() {
          function y() {
            this._key = p();
          }
          return y.prototype.has = function(C) {
            var S = g(
              C,
              /*create*/
              !1
            );
            return S !== void 0 ? R.has(S, this._key) : !1;
          }, y.prototype.get = function(C) {
            var S = g(
              C,
              /*create*/
              !1
            );
            return S !== void 0 ? R.get(S, this._key) : void 0;
          }, y.prototype.set = function(C, S) {
            var te = g(
              C,
              /*create*/
              !0
            );
            return te[this._key] = S, this;
          }, y.prototype.delete = function(C) {
            var S = g(
              C,
              /*create*/
              !1
            );
            return S !== void 0 ? delete S[this._key] : !1;
          }, y.prototype.clear = function() {
            this._key = p();
          }, y;
        }()
      );
      function p() {
        var y;
        do
          y = "@@WeakMap@@" + T();
        while (R.has(i, y));
        return i[y] = !0, y;
      }
      function g(y, C) {
        if (!r.call(y, u)) {
          if (!C)
            return;
          Object.defineProperty(y, u, { value: R.create() });
        }
        return y[u];
      }
      function D(y, C) {
        for (var S = 0; S < C; ++S)
          y[S] = Math.random() * 255 | 0;
        return y;
      }
      function w(y) {
        return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(y)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(y)) : D(new Uint8Array(y), y) : D(new Array(y), y);
      }
      function T() {
        var y = w(o);
        y[6] = y[6] & 79 | 64, y[8] = y[8] & 191 | 128;
        for (var C = "", S = 0; S < o; ++S) {
          var te = y[S];
          (S === 4 || S === 6 || S === 8) && (C += "-"), te < 16 && (C += "0"), C += te.toString(16).toLowerCase();
        }
        return C;
      }
    }
    function Ue(o) {
      return o.__ = void 0, delete o.__, o;
    }
  });
})(yt || (yt = {}));
class Bo {
  static generatePath(t, r, a = "pdf") {
    return Lr(t, r, a);
  }
  static chooseReportType(t, r) {
    const { confirm: a } = xt;
    a({
      okText: "PDF",
      closable: !0,
      onOk: t,
      cancelText: "Ticket",
      title: "Formato de impresión",
      content: "Escoja el formato del reporte",
      okButtonProps: {
        size: "large"
      },
      cancelButtonProps: {
        size: "large",
        type: "primary"
      },
      onCancel: () => na({
        documentId: `${r.documentId}`,
        documentTypeId: `${r.documentTypeId}`
      })
    });
  }
  static register(t, r) {
    r.addResourceBundle("en", "reporting_module", Zn), r.addResourceBundle("es", "reporting_module", ra), r.addResourceBundle("en", "error_reporting_module", et.en), r.addResourceBundle("es", "error_reporting_module", et.es), t.bind("Routes").toConstantValue(So());
  }
}
export {
  Bo as ReportingModule
};
